export default "__VITE_ASSET__DJPdMe9m__"